import { tx } from '@transifex/native'

tx.init({
  token: process.env.REACT_APP_TRANSIFEX_TOKEN,
  // Optional override of the translations CDS host (self-hosted mirror).
  // Unset -> SDK default (Transifex CDS), i.e. no behavior change.
  ...(process.env.REACT_APP_TRANSIFEX_CDS_HOST
    ? { cdsHost: process.env.REACT_APP_TRANSIFEX_CDS_HOST }
    : {}),
})
